export const getDmsUrl = (dmsId, dmsIndex) => buildUrl(dmsId, "image", dmsIndex)

export const getDmsFileUrl = (dmsId, dmsIndex) => buildUrl(dmsId, "file", dmsIndex)

export const getDmsStreamingUrl = (dmsId, dmsIndex) =>
    `${buildUrl(dmsId, 'streaming/adaptive', dmsIndex)}/index.m3u8`

export const getDeepZoomUrl = (dmsId, dmsIndex) =>
    `${buildUrl(dmsId, 'streaming/adaptive', dmsIndex)}/zi.dzi`

export const getAudioUrl = (dmsId, dmsIndex) =>
    `${buildUrl(dmsId, 'streaming/progressive', dmsIndex)}.mp3?mmid=${dmsId}&a=none`

const buildUrl = (dmsId, endpoint, dmsIndex=null) => {
    const generatedIndex = generateDmsIndex();
    return `https://dms-cf-${dmsIndex || generatedIndex}.dimu.org/${endpoint}/${dmsId}`;
}

const generateDmsIndex = () => {
    const randNum = Math.floor(Math.random() * 10) + 1;
    return randNum < 10 ? '0' + randNum : randNum;
}